module.exports = __webpack_public_path__ + "static/media/warning-yellow.54e1a32e.svg";